/* eslint-disable no-unused-vars */
export enum MissionType {
    INSTRUCTIONS = 'instructions',
    WELCOME = 'welcome',
    PICTURE = 'picture',
    INPUT_TEXT = 'input_text',
    INPUT_PLAYERS = 'input_players',
    INPUT_TEAM = 'input_team',
    PRIORITIZE = 'prioritize',
    CONNECTIONS = 'connections',
    SIMPLE_TEXT = 'simple_text',
    MULTIPLE_CHOICE = 'multiple_choice',
    INPUT_TOTAL_PLAYERS = 'input_total_players',
    FILL_IN_THE_BLANK = 'fill_in_the_blank',
    AUDIO = 'audio'
}
